import React from "react";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import Typed from "react-typed";
import makeStyles from "@material-ui/core/styles/makeStyles";
import resumeData from "../../utils/resume-data";
import Button from '@material-ui/core/Button';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';

const useStyles = makeStyles((theme) => ({
    avatar: {
        width: theme.spacing(30),
        height: theme.spacing(30),
        margin: theme.spacing(2),
        '@media (min-width:600px)': {
            width: theme.spacing(60),
            height: theme.spacing(60),
        },
    },
    title: {
        color: "whitesmoke",
        margin: theme.spacing(2),
        fontSize: '1.5rem',
        '@media (min-width:600px)': {
            fontSize: '2.5rem',
        },
    },
    subtitle: {
        color: "orange",
        textTransform: "uppercase",
        fontSize: '1rem',
        '@media (min-width:600px)': {
            fontSize: '1.5rem',
        },
    },
    para: {
        color: "#ccc",
        fontStyle: 'italic',
        fontSize: '1rem',
        textAlign: "center",
        margin: "10",
        padding: '2rem',
        fontWeight: 300,
        '@media (min-width:600px)': {
            fontSize: '1.2rem',
        },
        '@media (min-width:1024px)': {
            width: 650,
            fontSize: '1.3rem',
        },
    },
    typedContainer: {
        width: "100%",
        textAlign: "center",
        background: 'black',
        flexWrap: "wrap",
        flexGrow: 1,
        '@media (max-width:600px)': {
            paddingTop: '1.2rem',
        },
        '@media (min-width:1024px)': {
            paddingTop: '2rem',
        },
    },
    btn: {
        color: 'orange',
        '@media (min-width:600px)': {
            fontSize: '1rem',
        },
        '@media (min-width:1024px)': {
            fontSize: '1.2rem',
        },
    },

}));

const Home = () => {
    const classes = useStyles();

    function nl_pronounce() {
        if ('speechSynthesis' in window) {
            var msg = new SpeechSynthesisUtterance('Janarthani V Su-bramani-am');
            window.speechSynthesis.speak(msg);
        } else {
            alert('Sorry! its not supported by your browser.');
        }
    };

    return (
        <div className={classes.typedContainer}>
            <Grid container justify="center">
                <Avatar
                    className={classes.avatar}
                    rel="preload"
                    as="image"
                    src='https://res.cloudinary.com/janarthani/image/upload/v1627478444/Janarthani_uh2pff.jpg'
                    alt="Janarthani" />
            </Grid>
            <Typography className={classes.title}>
                <Typed strings={[`${resumeData.name}`]} typeSpeed={40} />
                <Button className={classes.title}
                    onClick={nl_pronounce}
                    aria-label="name-pronunciation" >
                    <VolumeUpIcon />
                </Button>
            </Typography>

            <Typography className={classes.subtitle}>
                <Typed
                    strings={[
                        "JavaScript Developer",
                        "Team Player",
                        "Self-Driven",
                        "Problem Solver",
                    ]}
                    typeSpeed={40}
                    backSpeed={50}
                    loop
                />
            </Typography>
            <Grid container justify="center">
                <Typography className={classes.para} variant="body1" gutterBottom>
                    {resumeData.shortintro}
                </Typography>
            </Grid>
            <Button className={classes.btn} variant="outlined" href="/about">
                Get to know me <DoubleArrowIcon />
            </Button>
        </div>
    );

}

export default Home


